import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getCursos,
  deleteCurso,
  changeStatusCurso,
  changeOrderCurso,
  changeStatusRegistroCurso,
  duplicarCurso,
  changeVisibleCurso,
} from "../../../../api/curso";
import { Button, Tooltip, TextField } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Lock,
  LockOpen,
  Search as SearchIcon,
} from "@material-ui/icons";
import { Copy, Eye, EyeClosed } from "lucide-react";

function getData(cursos) {
  const data = (cursos || [])
    .filter((c) => c?.tipoCurso === "continua_personalizada")
    .map((c) => {
      const elem = {};
      elem.titulo = c.titulo?.es || "";
      elem.order = c.order;
      elem.imageURL = c.imageURL;
      elem.code = c.code;
      elem.nRegistro = c.nRegistro;
      elem.creditos = c.creditosDefinidos === false ? "En trámite" : c.creditos;
      elem.fechaIni = c.fechaIni;
      elem.fechaFin = c.fechaFin;
      elem.visible = c.visible || false;
      elem.isZoom = c.isZoom || false;
      elem.createdAt = c.createdAt;
      elem.id = c._id;
      elem.active = c.active;
      elem.plazasLibres = "-";
      return elem;
    });
  data.sort((a, b) => (b.order ?? 0) - (a.order ?? 0));
  return data;
}

export default function FormacionesPersonalizadasPage() {
  const [data, setData] = useState([]);
  const [cursoId, setCursoId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [searchText, setSearchText] = useState("");
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const handleChangeOrder = (id, up) => {
    changeOrderCurso(id, up)
      .then(() => setRefresh(true))
      .catch(() => {});
  };

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    const displayed = data.filter((c) => c?.tipoCurso === "continua_personalizada");
    const maxOrder = displayed.length
      ? Math.max(...displayed.map((d) => d.order ?? 0))
      : 0;
    const minOrder = displayed.length
      ? Math.min(...displayed.map((d) => d.order ?? 0))
      : 0;
    const isFirst = elem?.order === maxOrder;
    const isLast = elem?.order === minOrder;

    return (
      <>
        {(user?.role === "admin" || user?.role === "consultor") && (
          <>
            {user?.role === "admin" && (
              <>
                <Tooltip title={"Subir (sumar 1)"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => handleChangeOrder(cell, true)}
                    disabled={isFirst}
                  >
                    <KeyboardArrowUp />
                  </Button>
                </Tooltip>
                <Tooltip title={"Bajar (restar 1)"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => handleChangeOrder(cell, false)}
                    disabled={isLast}
                  >
                    <KeyboardArrowDown />
                  </Button>
                </Tooltip>
              </>
            )}
            <Tooltip title="Edit">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => history.push("/edit-formacion-personalizada/" + cell)}
              >
                <EditIcon />
              </Button>
            </Tooltip>
            {user?.role === "admin" && (
              <>
                <Tooltip title="Duplicar">
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(4);
                    }}
                  >
                    <Copy />
                  </Button>
                </Tooltip>
                <Tooltip title={elem?.registroWeb ? "Editable" : "Protegido"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(3);
                    }}
                  >
                    {elem?.registroWeb ? <LockOpen /> : <Lock style={{ color: "red" }} />}
                  </Button>
                </Tooltip>
                <Tooltip title={elem?.visible ? "Visible" : "Ocultar"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(5);
                    }}
                  >
                    {elem?.visible ? <Eye /> : <EyeClosed style={{ color: "red" }} />}
                  </Button>
                </Tooltip>
                <Tooltip title={elem?.active ? "Disable" : "Enable"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(elem);
                      setOpenConfirmDialog(1);
                    }}
                  >
                    {elem?.active ? <ToggleOffIcon /> : <ToggleOnIcon style={{ color: "red" }} />}
                  </Button>
                </Tooltip>
                <Tooltip title="Delete">
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setCursoId(cell);
                      setOpenConfirmDialog(2);
                    }}
                  >
                    <DeleteIcon />
                  </Button>
                </Tooltip>
              </>
            )}
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "code", text: "Código", sort: true },
    { dataField: "titulo", text: "Título", sort: true },
    { dataField: "fechaIni", text: "Fecha Inicio", sort: true },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getCursos()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data || []);
          setRefresh(false);
        }
      })
      .catch(() => {});
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Formaciones continuas personalizadas">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-formacion-personalizada")}
              startIcon={<AddIcon />}
              style={{ backgroundColor: "#f3691a", color: "#fff" }}
            >
              Añadir nueva
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="row align-items-end" style={{ marginBottom: 15 }}>
            <div className="col-md-4 col-sm-6 mb-2">
              <TextField
                id="search"
                label="Buscar"
                placeholder="Buscar..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value || "")}
                margin="dense"
                variant="outlined"
                fullWidth
              />
            </div>
            <div className="col-md-3 col-sm-6 mb-2">
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                style={{ backgroundColor: "#f3691a", color: "#fff" }}
                onClick={() => {}}
              >
                Buscar
              </Button>
            </div>
          </div>

          <Table
            data={getData(
              searchText
                ? data.filter((c) => {
                    const t = (c.titulo?.es || "").toLowerCase();
                    const code = (c.code || "").toLowerCase();
                    const s = searchText.toLowerCase();
                    return t.includes(s) || code.includes(s);
                  })
                : data,
            )}
            columns={columns}
            pageKey="formacionesPersonalizadasPage"
            searchText={searchText}
            onSearchChange={setSearchText}
          />

          <ConfirmDialog
            title={`Are you sure you want to ${cursoId?.active ? "disable" : "enable"} this curso?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusCurso(cursoId._id, !cursoId?.active)
                .then(() => setRefresh(true))
                .catch(() => {});
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this curso?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCurso(cursoId)
                .then(() => setRefresh(true))
                .catch(() => {});
            }}
          />
          <ConfirmDialog
            title={`Estas seguro que quieres ${cursoId?.registroWeb ? "Protejer" : "Editable"} el registro de este curso?`}
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusRegistroCurso(cursoId._id, !cursoId?.registroWeb)
                .then(() => setRefresh(true))
                .catch(() => {});
            }}
          />
          <ConfirmDialog
            title={`Estas seguro que quieres duplicar el registro de este curso?`}
            open={openConfirmDialog === 4}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              duplicarCurso(cursoId._id, cursoId)
                .then(() => setRefresh(true))
                .catch(() => {});
            }}
          />
          <ConfirmDialog
            title={`Estas seguro que quieres ${cursoId?.visible ? "despublicar" : "publicar"} curso en la web?`}
            open={openConfirmDialog === 5}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeVisibleCurso(cursoId._id, !cursoId?.visible)
                .then(() => setRefresh(true))
                .catch(() => {});
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}

